import { useSelector } from "react-redux";
import NavigationBar from "../Common/NavigationBar";

import { authorized } from "../../utils/authorizationUtils";

import {
  bypatruljen,
  bypatruljenAll,
  juridisk,
  juridiskAll,
  skiftlogg,
} from "../../constants/roles";
import sitePaths from "../../constants/sitePaths";

import "./rapporter.css";

function NavigationBarContainer() {
  // Subscribe to login so the nav re-renders on auth change
  useSelector((state) => state.login);

  const authorizedVentilstilling = authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    bypatruljen.avdelingdirektor,
    bypatruljen.seksjonssjefStab,
    bypatruljen.seksjonssjef,
    bypatruljen.driftleder,
    bypatruljen.stedfortrederDriftsleder,
    ...juridiskAll,
  ]);

  const authorizedKlager = authorized([
    juridisk.ledelse,
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    bypatruljen.avdelingdirektor,
    bypatruljen.seksjonssjefStab,
  ]);

  const authorizedUferdigstilteKlagesaker = authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    bypatruljen.avdelingdirektor,
    ...juridiskAll,
  ]);

  const authorizedSkiftlogg = authorized([skiftlogg, ...bypatruljenAll]);

  const authorizedPiggdekkontroll = authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    bypatruljen.avdelingdirektor,
    bypatruljen.seksjonssjefStab,
    bypatruljen.seksjonssjef,
    bypatruljen.driftleder,
    bypatruljen.stedfortrederDriftsleder,
    ...juridiskAll,
  ]);

  const authorizedAntallIleggelserPerIleggelsetype = authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    bypatruljen.avdelingdirektor,
    bypatruljen.seksjonssjefStab,
    bypatruljen.seksjonssjef,
    bypatruljen.driftleder,
    ...juridiskAll,
  ]);

  const authorizedMakuleringer = authorized([
    bypatruljen.avdelingdirektor,
    bypatruljen.seksjonssjefStab,
    bypatruljen.saksbehandleradmin,
    bypatruljen.saksbehandler,
  ]);

  const authorizedAArsrapport = authorized([
    bypatruljen.saksbehandler,
    bypatruljen.saksbehandleradmin,
    bypatruljen.avdelingdirektor,
    bypatruljen.seksjonssjefStab,
    bypatruljen.seksjonssjef,
    bypatruljen.driftleder,
    ...juridiskAll,
  ]);

  const authorizedUbetalteIleggelser = authorized([
    bypatruljen.saksbehandleradmin,
    bypatruljen.saksbehandler,
    bypatruljen.seksjonssjefStab,
  ]);

  const navigationItems = [];
  if (authorizedVentilstilling) {
    navigationItems.push({
      navn: "Ventilstillingskontroll",
      path: sitePaths.rapporter.ventilstillinger.oversikt,
    });
  }
  if (authorizedUbetalteIleggelser) {
    navigationItems.push({
      navn: "Ubetalte Ileggelser",
      path: sitePaths.rapporter.ubetalteIleggelser.oversikt,
    });
  }
  if (authorizedSkiftlogg) {
    navigationItems.push({
      navn: "Skiftlogg",
      path: sitePaths.rapporter.skiftlogg.oversikt,
    });
  }
  if (authorizedPiggdekkontroll) {
    navigationItems.push({
      navn: "Piggdekkontroll",
      path: sitePaths.rapporter.piggdekkontroller.oversikt,
    });
  }
  if (authorizedKlager) {
    navigationItems.push({
      navn: "Klager",
      path: sitePaths.rapporter.klager.oversikt,
    });
  }
  if (authorizedUferdigstilteKlagesaker) {
    navigationItems.push({
      navn: "Uferdigstilte klagesaker",
      path: sitePaths.rapporter.uferdigstilteKlagesaker.oversikt,
    });
  }
  if (authorizedAntallIleggelserPerIleggelsetype) {
    navigationItems.push({
      navn: "Antall ileggelser per ileggelsetype",
      path: sitePaths.rapporter.antallIleggelserPerIleggelsetype.oversikt,
    });
  }
  if (authorizedMakuleringer) {
    navigationItems.push({
      navn: "Makuleringer",
      path: sitePaths.rapporter.makuleringer.oversikt,
    });
  }
  if (authorizedAArsrapport) {
    navigationItems.push({
      navn: "Årsrapport",
      path: sitePaths.rapporter.aarsrapport.oversikt,
    });
  }

  return <NavigationBar navigationItems={navigationItems} />;
}

export default NavigationBarContainer;
